/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSplit
 */
export interface PaymentSplit {
    /**
     * 
     * @type {number}
     * @memberof PaymentSplit
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplit
     */
    percentage: number;
}

/**
 * Check if a given object implements the PaymentSplit interface.
 */
export function instanceOfPaymentSplit(value: object): value is PaymentSplit {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "percentage" in value && value["percentage"] !== undefined;

    return isInstance;
}

export function PaymentSplitFromJSON(json: any): PaymentSplit {
    return PaymentSplitFromJSONTyped(json, false);
}

export function PaymentSplitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSplit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'percentage': json['percentage'],
    };
}

export function PaymentSplitToJSON(value?: PaymentSplit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'percentage': value.percentage,
    };
}

